import { Button, SaveIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useConfirm } from "melco-shared-logic";
import { useUserWizardAdd } from "../../hooks/dashboard/useUserWizardAdd";

type AddRemoveWizardProps = {
    selectedRows: any;

    callback?: () => void;
};

export const AddRemoveWizardButton: React.FC<
    AddRemoveWizardProps
> = ({ callback, selectedRows }) => {
    const { t } = useTranslation();

    const addRemoveWizard = useUserWizardAdd();

    const confirmAdd = useConfirm(
        async () => {
            await addRemoveWizard(
                selectedRows
            );



            if (callback) {
                callback();
            }


        },
        {
            translationPrefix: "dashboard.wizards.actions.add",


        }
    );


    return (
        <Button
            key="bulk-download"
            type="primary"
            icon={<SaveIcon />}
            onClick={async () => {
                await confirmAdd();
            }}
        >
            {t("dashboard.wizards.actions.add.button")}

        </Button>
    );
};
